import React, { useState } from 'react';
import SEO from '../../components/SEO';
import Layout from '../../components/Layout';
import Container from '../../components/Container';
import { Desktop, Tablet } from '../../constants/responsive';
import { css } from '@emotion/core';
import { useStaticQuery, graphql } from 'gatsby';
import { FormattedHTMLMessage, useIntl } from 'gatsby-plugin-intl';
import GeneralBanner from '../../components/GeneralBanner';
import { mainColor } from '../../constants/colors';
import { useSessionStorage, useMount, useEffectOnce } from 'react-use';

const FAQPage = () => {
  const intl = useIntl();

  const data = useStaticQuery(graphql`
    query {
      allFaq {
        edges {
          node {
            id
            faq_id
            locale
            question
            answer
            tag
          }
        }
      }
    }
  `);

  const faqs = data.allFaq.edges
    .map((node) => node.node)
    .filter((faq) => faq.locale === intl.locale);

  const tags = [
    ...new Set(
      data.allFaq.edges
        .map((node) => node.node)
        .filter((faq) => faq.locale === intl.locale)
        .map((faq) => faq.tag)
        .flat()
    ),
  ];

  const [selectedTagIndex, setSelectedTagIndex] = useSessionStorage(
    'faq-selected-tag',
    0
  );
  const [selectedFaq, setSelectedFaq] = useSessionStorage(
    'faq-selected-faq',
    faqs.filter((faq) => faq.tag === tags[selectedTagIndex])[0].faq_id
  );
  const [isClient, setClient] = useState(false);
  useMount(() => {
    setClient(true); // 用来改变key,使得组件重新渲染
  });

  return (
    <Layout footerBlank>
      <SEO
        title={intl.formatMessage({ id: 'faq.title' })}
        description={intl.formatMessage({ id: 'faq.description' })}
        keywords={intl.formatMessage({ id: 'faq.keywords' })}
      />
      <GeneralBanner>
        <FormattedHTMLMessage id='faq.title' />
      </GeneralBanner>
      <Container
        css={css`
          margin-top: 100px;
          ${Desktop} {
            margin-top: 200px;
          }
          visibility: ${isClient ? 'visible' : 'hidden'};
        `}
        key={`container-${isClient}`}
      >
        {/* 【问题tags】 */}
        <div
          css={css`
            display: flex;
            justify-content: flex-start;
            ${Tablet} {
              // justify-content: space-between;
            }
            ${Desktop} {
              justify-content: space-between;
            }
            flex-wrap: wrap;
          `}
        >
          {tags.map((tag, index) => {
            return (
              <div
                key={`${tag}-${isClient}`}
                onClick={() => {
                  setSelectedTagIndex(index);
                  setSelectedFaq(
                    faqs.filter((faq) => faq.tag === tag)[0].faq_id
                  );
                }}
                css={css`
                  width: 120px;
                  height: 40px;
                  font-size: 12px;
                  margin-right: 20px;
                  margin-bottom: 20px;
                  ${Tablet} {
                    margin-right: ${index % 3 === 2 ? 0 : 33}px;
                    width: 220px;
                    height: 60px;
                    font-size: 16px;
                  }
                  ${Desktop} {
                    margin-right: 0;
                    font-size: 20px;
                    width: 280px;
                    height: 80px;
                  }
                  border-radius: 15px;
                  background: ${selectedTagIndex === index
                    ? mainColor
                    : '#f2f2f2'};
                  color: ${selectedTagIndex === index ? 'white' : 'black'};
                  font-weight: bold;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  user-select: none;
                  cursor: pointer;
                  transition: all 0.2s ease;
                `}
              >
                {tag}
              </div>
            );
          })}
        </div>
        {/* 【具体问题与答案】- MOBILE端 */}
        <div
          css={css`
            display: block;
            ${Tablet} {
              display: none;
            }
          `}
        >
          {faqs
            .filter((faq) => faq.tag === tags[selectedTagIndex])
            .map((faq) => {
              const selected = faq.faq_id === selectedFaq;
              return (
                <div
                  key={`${faq.id}-${isClient}`}
                  css={css`
                    border-bottom: 1px solid #bababa;
                  `}
                >
                  <div
                    css={css`
                      font-size: 16px;
                      line-height: 22px;
                      line-height: 30px;
                      padding-bottom: 20px;
                      padding-top: 20px;
                      padding-right: 20px;
                      cursor: pointer;
                      color: ${selected ? mainColor : 'black'};
                      font-weight: ${selected ? 'bold' : 'normal'};
                      position: relative;
                    `}
                    onClick={() => {
                      setSelectedFaq(faq.faq_id);
                    }}
                  >
                    {faq.question}
                    <div
                      css={css`
                        width: 12px;
                        height: 2px;
                        border-radius: 2px;
                        background: black;
                        position: absolute;
                        top: 50%;
                        right: -4px;
                        transform: translate(-50%, -50%)
                          ${selected ? 'rotate(45deg)' : 'rotate(-45deg)'};
                        transition: all 0.2s ease;
                      `}
                    />
                    <div
                      css={css`
                        width: 12px;
                        height: 2px;
                        border-radius: 2px;
                        background: black;
                        position: absolute;
                        top: 50%;
                        right: 4px;
                        transform: translate(-50%, -50%)
                          ${selected ? 'rotate(-45deg)' : 'rotate(45deg)'};
                        transition: all 0.2s ease;
                      `}
                    />
                  </div>
                  {selected && (
                    <div
                      css={css`
                        margin-bottom: 20px;
                        a[href] {
                          color: ${mainColor} !important;
                          &:hover {
                            opacity: 0.8;
                          }
                        }
                        * {
                          font-family: inherit !important;
                          font-size: 16px !important;
                          line-height: 20px !important;
                        }
                        table,
                        table td,
                        table th,
                        table tbody {
                          border: 1px solid #ff0000 !important;
                          border-collapse: collapse;
                        }
                        table td {
                          padding-left: 10px;
                        }
                        img {
                          width: 100% !important;
                          height: 100% !important;
                        }
                        ${Desktop} {
                          * {
                            font-family: inherit !important;
                            font-size: 20px !important;
                            line-height: 30px !important;
                          }
                        }
                        p {
                          margin-bottom: 10px !important;
                        }
                        ul,
                        ol {
                          padding-left: 20px !important;
                        }
                        li {
                          padding-left: 5px !important;
                          margin-bottom: 10px !important;
                        }
                      `}
                      dangerouslySetInnerHTML={{ __html: faq.answer }}
                    />
                  )}
                </div>
              );
            })}
        </div>
        {/* 【具体问题与答案】- WEB、IPAD端 */}
        <div
          css={css`
            display: none;
            ${Tablet} {
              display: flex;
            }
          `}
        >
          <div
            css={css`
              flex: 0 0 250px;
              margin-right: 20px;
              max-height: 580px;
              overflow-y: auto;
              ${Desktop} {
                // margin-top: 35px;
                margin-right: 80px;
                flex: 0 0 400px;
              }
            `}
          >
            {faqs
              .filter((faq) => faq.tag === tags[selectedTagIndex])
              .map((faq) => {
                return (
                  <div
                    key={faq.id}
                    css={css`
                      border-bottom: 1px solid #bababa;
                      line-height: 30px;
                      font-size: 16px;
                      padding-bottom: 20px;
                      padding-top: 20px;
                      ${Desktop} {
                        font-size: 25px;
                        padding-bottom: 12px;
                        padding-top: 35px;
                      }
                      cursor: pointer;
                      color: ${faq.faq_id === selectedFaq
                        ? mainColor
                        : 'black'};
                      font-weight: ${faq.faq_id === selectedFaq
                        ? 'bold'
                        : 'normal'};
                    `}
                    onClick={() => {
                      setSelectedFaq(faq.faq_id);
                    }}
                  >
                    {faq.question}
                  </div>
                );
              })}
          </div>
          <div
            css={css`
              flex: 1;
            `}
          >
            {faqs
              .filter((faq) => faq.faq_id === selectedFaq)
              .map((faq) => {
                return (
                  <div
                    key={faq.id}
                    css={css`
                      background: #f2f2f2;
                      padding: 40px;
                      border-radius: 15px;
                      margin-top: 20px;
                      ${Desktop} {
                        margin-top: 35px;
                      }
                    `}
                  >
                    <div
                      css={css`
                        a[href] {
                          color: ${mainColor} !important;
                          &:hover {
                            opacity: 0.8;
                          }
                        }
                        * {
                          font-family: inherit !important;
                          font-size: 16px !important;
                          line-height: 20px !important;
                        }
                        table,
                        table td,
                        table th,
                        table tbody {
                          border: 1px solid #ff0000 !important;
                          border-collapse: collapse;
                        }
                        table td {
                          padding-left: 10px;
                        }
                        img {
                          width: 100% !important;
                          height: 100% !important;
                        }
                        ${Desktop} {
                          * {
                            font-family: inherit !important;
                            font-size: 20px !important;
                            line-height: 30px !important;
                          }
                        }
                        p {
                          margin-bottom: 10px !important;
                        }
                        ul,
                        ol {
                          padding-left: 20px !important;
                        }
                        li {
                          padding-left: 5px !important;
                          margin-bottom: 10px !important;
                        }
                      `}
                      dangerouslySetInnerHTML={{ __html: faq.answer }}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      </Container>
    </Layout>
  );
};

export default FAQPage;
